// Comprehensive list of Mumbai, Navi Mumbai, and Thane locations

export const MUMBAI_LOCATIONS = [
  // South Mumbai
  'Churchgate', 'Marine Lines', 'Charni Road', 'Grant Road', 'Mumbai Central',
  'Mahalaxmi', 'Lower Parel', 'Prabhadevi', 'Dadar', 'Matunga', 'Sion',
  'Kurla', 'Vidyavihar', 'Ghatkopar', 'Vikhroli', 'Kanjurmarg', 'Bhandup',
  'Nahur', 'Mulund',
  
  // Western Line
  'Bandra', 'Khar', 'Santacruz', 'Vile Parle', 'Andheri', 'Jogeshwari',
  'Ram Mandir', 'Goregaon', 'Malad', 'Kandivali', 'Borivali', 'Dahisar',
  'Mira Road', 'Bhayandar', 'Naigaon', 'Vasai', 'Virar',
  
  // Harbour Line
  'Cotton Green', 'Reay Road', 'Dockyard Road', 'Sandhurst Road',
  'Masjid Bunder', 'Byculla', 'Chinchpokli', 'Curry Road',
  'Parel', 'Elphinstone Road', 'Mahim', 'Khar Road',
  
  // Important Areas & Localities
  'Colaba', 'Fort', 'Ballard Estate', 'Kalbadevi', 'Girgaon',
  'Tardeo', 'Breach Candy', 'Worli', 'Lalbaug', 'Dharavi',
  'Wadala', 'Antop Hill', 'Chembur', 'Mankhurd', 'Govandi',
  'Powai', 'Chandivali', 'Sakinaka', 'Marol', 'Chakala',
  'Versova', 'Oshiwara', 'Lokhandwala', 'Four Bungalows',
  'Gorai', 'Madh Island', 'Aksa', 'Marve',
  
  // Business Districts & Key Areas
  'BKC (Bandra Kurla Complex)', 'Nariman Point', 'Cuffe Parade', 'Worli Sea Face',
  'Dadar TT', 'Sion Circle', 'King Circle', 'Matunga Road',
  
  // Eastern Suburbs
  'Bhandup East', 'Bhandup West', 'Vikhroli East', 'Vikhroli West',
  'Ghatkopar East', 'Ghatkopar West', 'Kurla East', 'Kurla West',
  'Chembur East', 'Chembur West', 'Tilak Nagar', 'Chunabhatti',
  
  // Western Suburbs
  'Andheri East', 'Andheri West', 'Jogeshwari East', 'Jogeshwari West',
  'Goregaon East', 'Goregaon West', 'Malad East', 'Malad West',
  'Kandivali East', 'Kandivali West', 'Borivali East', 'Borivali West',
  
  // Additional Key Areas
  'Mumbra', 'Diva', 'Sewri', 'GTB Nagar', 'Mankhurd',
  'Trombay', 'Cheetah Camp', 'Baiganwadi', 'Kanjur Village',
];

export const NAVI_MUMBAI_LOCATIONS = [
  // Nodes
  'Airoli', 'Ghansoli', 'Koparkhairane', 'Vashi', 'Sanpada',
  'Juinagar', 'Nerul', 'Seawoods', 'Belapur', 'Kharghar',
  'Mansarovar', 'Khandeshwar', 'Panvel',
  
  // Sectors & Areas
  'Vashi Sector 1-28', 'Nerul Sector 1-50', 'Belapur Sector 1-25',
  'Kharghar Sector 1-35', 'Kamothe', 'New Panvel',
  'Turbhe', 'Kopar Khairane', 'Rabale', 'Digha', 
  'Kalamboli', 'Taloja', 'Ulwe', 'Dronagiri', 'Uran', 'Pen',
  
  // Additional Areas
  'CBD Belapur', 'Vashi Village', 'Nerul West', 'Nerul East',
  'Kharghar Hills', 'Karanjade', 'Khanda Colony',
];

export const THANE_LOCATIONS = [
  // Main Thane
  'Thane East', 'Thane West', 'Thane Station',
  
  // Thane Areas
  'Ghodbunder Road', 'Majiwada', 'Manpada', 'Kapurbawdi',
  'Naupada', 'Kopri', 'Vartak Nagar', 'Wagle Estate',
  'Louis Wadi', 'Azad Nagar', 'Kalwa', 'Parsik', 'Shil', 'Rabodi',
  
  // Extended Areas
  'Kolshet', 'Hiranandani Estate', 'Pokhran Road', 'Teenage', 
  'Owale', 'Balkum', 'Brahmand', 'Teen Hath Naka',
  'Panchpakhadi', 'Kasheli', 'Mumbra', 'Diva',
  
  // Beyond Thane
  'Bhiwandi', 'Kalyan East', 'Kalyan West', 'Dombivli East', 
  'Dombivli West', 'Ambernath', 'Badlapur', 'Ulhasnagar',
  'Vithalwadi', 'Titwala', 'Khadavli', 'Shahad', 'Vangani',
  
  // Thane Creek Areas
  'Airoli Bridge', 'Kopri Bridge', 'Mumbra Bypass',
];

// Combined and sorted list with duplicates removed
export const ALL_LOCATIONS = [
  ...new Set([
    ...MUMBAI_LOCATIONS,
    ...NAVI_MUMBAI_LOCATIONS,
    ...THANE_LOCATIONS,
  ])
].sort();
